import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, catchError, throwError, from, switchMap, EMPTY } from 'rxjs';
import { IAuthenticationService } from '../interfaces/authentication-service.interface';
import { AuthenticationService_TOKEN } from '../tokens/injection-tokens';
import { LocalStorageWrapper } from '../classes/local-storage-wrapper.class';
import { FormatService } from '../services/format.service';
import { AuthSubscriptionService } from '../services/auth-subscription.service';

@Injectable({
    providedIn: 'root'
})
export class HttpErrorHandlerService implements HttpInterceptor {

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        @Inject(AuthenticationService_TOKEN)
        private authenticationService: IAuthenticationService,
        private formatService: FormatService,
        private authSubscriptionService: AuthSubscriptionService
    ) { }
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    console.log('HTTPErrorHandlerService');
                    console.log(error);
                    console.log(this.router.url);
                    if (error.status != 504 &&
                        error.status != 500 &&
                        error.status != 401 &&
                        error.status != 400 &&
                        error.status != 0) {
                        const errorMessage = `${JSON.stringify(error)} - ${this.formatService.formatDateTime(new Date())}`;
                        alert("HttpErrorHandlerService - " + errorMessage);
                    }

                    if (error.status === 401 && this.router.url !== '/authentication/login') {
                        return from(this.authenticationService.tryRefreshingTokens()).pipe(
                            switchMap(refreshSucceeded => {
                                if (refreshSucceeded) {
                                    this.authSubscriptionService.sendAuthStateChangeNotification(true);
                                    req = req.clone({
                                        setHeaders: {
                                            Authorization: `Bearer ${LocalStorageWrapper.getToken()}`,
                                        }
                                    });
                                    return next.handle(req);
                                } else {
                                    this.authenticationService.logout();
                                    return EMPTY;
                                }
                            }),
                        );
                    }
                    return throwError(() => error);
                }))
    }
}
